import { displayLatLonInCompassFormat } from '@deckee/utilities';
import React from 'react';
import { boatRamp } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Boat ramp',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'boat-ramp',
  icon: {
    baseShape: boatRamp,
    iconColor: '#fff',
    markerColor: '#56AC5C',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-facilities',
    order: 25,
  },
  standardMarkerOptions: {
    markerType: 'boatRampMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Boat ramp',
      itemTitleFunction: (item) =>
        item && item.geoJson && item.geoJson.properties
          ? `${
              item.geoJson.properties.title ||
              item.geoJson.properties.boat_ramp_name
            } ${item.geoJson.properties.waterway_name}`
          : 'Boat ramp',
    },
    creationOptions: {
      menuText: 'Boat ramp',
      newTitle: 'Boat ramp',
      titlePlaceholder: 'Name of boat ramp',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          Include information such as number of lanes, access times, ramp
          construction material and contact details.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [
        { label: 'Limited car parking (less than 10 spaces)', isActive: false },
        { label: 'Moderate car parking (11-30 spaces)', isActive: false },
        { label: 'Good car parking (31 or more spaces)', isActive: false },
        { label: 'Poor ramp condition', isActive: false },
        { label: 'Average ramp condition', isActive: false },
        { label: 'Good ramp condition', isActive: false },
        { label: "BBQ's", isActive: false },
        { label: 'Bins', isActive: false },
        { label: 'Fish cleaning table', isActive: false },
        { label: 'Fuel available', isActive: false },
        { label: 'Fee payable', isActive: false },
        { label: 'Kiosk', isActive: false },
        { label: 'Lighting', isActive: false },
        { label: 'Pontoon nearby', isActive: false },
        { label: 'Pontoon ramp', isActive: false },
      ],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: false,
    title: 'Boat ramp',
    description:
      marker && marker.geoJson && marker.geoJson.properties
        ? `${
            marker.geoJson.properties.title ||
            marker.geoJson.properties.boat_ramp_name
          } ${marker.geoJson.properties.waterway_name || ''}`
        : displayLatLonInCompassFormat(marker.latLon) || ' ',
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
